import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import TodoDataService from '../../hooks/services'

import CAvisoPrivacidad from "../../components/Aviso_Privicidad";
import EmailConfirmacion from "../../components/Email_Confirmacion";
import NotaVenta from '../../components/Nota_Venta';
import HorizontalLinearStepper from "../../components/Stepper";

import ButtonConmemoracion from "./ButtonConmemoracion";
// -----------Importar Componentes de Terceros------------------
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PaymentsIcon from '@mui/icons-material/Payments';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CompareArrowsSharpIcon from '@mui/icons-material/CompareArrowsSharp';

import faceboock from '../../assets/Imagenes/Sets/faceboock.png'
import instagran from '../../assets/Imagenes/Sets/instagran.png'
import ticktock from '../../assets/Imagenes/Sets/ticktock.png'

import StyleDragArea from './css/button';
import './css/style.css'


import { Route } from "react-router-dom";

const ListTypo = [{ id: 1, Nombre: 'Sepultura' }, { id: 2, Nombre: 'Cremación' }];

const ListSets = [
  {
    "id": "1",
    "nombre": "Velación en Sala",
    "nombre2": "Velación en Sala",
    "precio": "11,000.00",
    "beneficios": ["Traslados", "Ataúd*", "Sala 24 horas", "Trámites"]
  },
  {
    "id": "2",
    "nombre": "Velación en Casa",
    "nombre2": "Velación en Casa",
    "precio": "10,500.00",
    "beneficios": ["Traslados", "Ataúd*", "Equipo de velación", "Trámites"]
  }, {
    "id": "3",
    "nombre": "Servicio Directo",
    "nombre2": "Servicio Directo",
    "precio": "9,000.00",
    "beneficios": ["Traslados", "Ataúd*", "Trámites"]
  }]



class SetFunerariosAgradecimientos extends Component {
  state = {
    Error: '',
    Route: null,
  }





  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  componentDidMount() {
    let appState = JSON.parse(localStorage.getItem('appState'));

    if (appState) {
      this.scrollToTop();
      appState.StepLenght = 4;
      appState.DataDetalleDetalleSetsFuenerarios.Estado.nombre = appState.DataEstado.find(estado => estado.estadoId.trim() === appState.FormFinado.Estado).nombre
      appState.DataDetalleDetalleSetsFuenerarios.Municipio.nombre = appState.DataMunicipio.find(municipio => municipio.municipioId.trim() === appState.FormFinado.Municipio).nombre
      appState.DataDetalleDetalleSetsFuenerarios.Colonia.nombre = appState.DataColonia.find(colonia => colonia.asentamientoId.trim() === appState.FormFinado.Colonia).nombre

      appState.DetalleSetsFuenerarios = true;
      this.setState(appState);
      console.log(appState);
    } else {
      this.setState({
        Route: '/SetsFunerarios',
        shouldRedirect: true
      });
    }
  }
  CopiarFolioSession = () => {
    sessionStorage.setItem("folio", this.state.FormPago.PedidoCliente.folio);
  }
  formatearComoMonedaMXN = (cantidad) => {
    const formatoMonedaMXN = new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
    });
    return formatoMonedaMXN.format(cantidad);
  };


  formatearComoMonedaMXN = (cantidad) => {
    const formatoMonedaMXN = new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
    });
    return formatoMonedaMXN.format(cantidad);
  };


  TipoPago = (FormPago) => {

    return (
      <Box sx={{ borderRadius: '5px', backgroundColor: '#FFEC00', width: '170px', padding: '2px', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
        {
          FormPago.Tipo === '0'
            ?
            <>
              <CreditCardIcon sx={{ color: '#374957' }} />
              <Typography fontWeight='700 !important' fontSize='18px' color='#374957'>Crédito / Débito</Typography>
            </>
            :
            FormPago.Tipo === '1'
              ?
              <>
                <PaymentsIcon sx={{ color: '#374957' }} />
                <Typography fontWeight='700 !important' fontSize='18px' color='#374957'>Efectivo</Typography>
              </>
              :
              FormPago.Tipo === '2'
                ?
                <>
                  <CompareArrowsSharpIcon sx={{ color: '#374957' }} />
                  <Typography fontWeight='700 !important' fontSize='18px' color='#374957'>Trasferencia</Typography>
                </>
                :
                <Typography fontWeight='700 !important' fontSize='18px' color='#374957'>Tipo de pago no válido</Typography>
        }
      </Box>
    );


  }

  render() {
    if (this.state.shouldRedirect) {
      return <Navigate to={this.state.Route} replace />;
    }

    if (
      !this.state.FormPago ||
      !this.state.FormPago.PedidoCliente ||
      !this.state.DataDetalleDetalleSetsFuenerarios
    ) {
      return null; // O un spinner de carga
    }


    console.log(this.state.FormPago.PedidoCliente.contactoCliente);

    return (
      <Box mb={{ xs: '70px !important', sm: '120px !important' }} mt={{ xs: '40px !important', sm: '105px !important' }}>
        <Container sx={{ marginBottom: '0px', padding: '0px 16px !important', maxWidth: '1170px !important' }}>

          <Box className='row Escritorio'>
            <Box className='col-sm-7' pl='0px !important' pr={{ xs: '0px', sm: '40px !important' }}>


              <Box className='BoxLMB1'>
                <Typography variant="h1" className="TituloGracias">Confirmación de pedido</Typography>
                <Box className='Start'>
                  <Typography className="SubTitulo" mr={1}>Número de folio</Typography>
                  <Typography className="SubTitulo Rs">#{this.state.FormPago.PedidoCliente.folio}</Typography>
                </Box>
              </Box>


              <Box className='BoxLMB2'>
                <Typography variant="h2" className="Titulo2">Hola @{this.state.FormPago.PedidoCliente.contactoCliente.nombreCompleto}</Typography>
                <Typography className="SubTitulo2">
                  Gracias por confiar en nosotros. Tu pedido se ha confirmado, aquí puedes ver los detalles de tu pedido.
                </Typography>
              </Box>

              <Box className='BoxLMB3-2'>
                <Typography variant="h3" className="Titulo3">
Este correo electrónico NO es una confirmación de pago, sino una confirmación de pedido.                
</Typography>
              </Box>


              <Box className='BoxLMB3'>
                <Typography variant="h3" className="Titulo3">
                  Tu comprobante de pago deberá ser compartido a nuestros asesores, por medio de WhatsApp {this.state.FormPago.PedidoCliente.contactoCliente.telefono} o correo electrónico {this.state.FormPago.PedidoCliente.contactoCliente.email}.
                </Typography>
              </Box>


              <Box className='BoxLMB4 '>
                <Typography className="SubTitulo2" display='inline' >
                  Esta notificación fue enviada al correo electrónico ingresado en
                  <Typography className="SubTitulo2 Rs" display='inline'> {TodoDataService.GetHost2()} </Typography>
                  <Typography className="SubTitulo2" >
                    Si necesitas alguna aclaración de dudas o servicio al cliente, comunícate al:
                  </Typography>
                </Typography>
              </Box>


              <Box className='BoxLMB5'>
                <Typography variant="h4" className="Titulo2">{TodoDataService.GetNumberCall()}</Typography>
              </Box>

              <Box className='BoxLMB6'>
                <Typography className="SubTitulo2">Síguenos en nuestras redes sociales</Typography>
              </Box>


              <Box display='flex' >
                <img className="ImgRedes" alt="redes" src={faceboock} style={{ cursor: 'pointer', margin: '0px 10px' }} onClick={() => window.open("https://www.facebook.com/funeralescolumba", "_blank")}
                />
                <img className="ImgRedes" alt="redes" src={instagran} style={{ cursor: 'pointer', margin: '0px 10px' }} onClick={() => window.open("https://www.instagram.com/columbafunerales/", "_blank")}
                />
                <img className="ImgRedes" alt="redes" src={ticktock} style={{ cursor: 'pointer', margin: '0px 10px' }} onClick={() => window.open("https://www.tiktok.com/@funeralescolumba", "_blank")}
                />
              </Box>




              <Typography className="SubTitulo2">
                El correo electrónico se genera automáticamente
              </Typography>

              <Typography className="SubTitulo2">Por favor, no respondas.</Typography>

              <ButtonConmemoracion CopiarFolioSession={ this.CopiarFolioSession} />


            </Box>
            <Box className='col-sm-5' pl='20px !important' pr='0px !important'>


              <Box className='Box1' >
                <Box className='Between' mb='20px'>
                  <Typography className="TituloBox">Costo del servicio</Typography> <Box> {this.TipoPago(this.state.FormPago)}</Box>
                </Box>
                <Box className='Between'>
                  <Typography className="TituloBox"> Total pagado:</Typography>  <Typography className="TotalBox">{this.formatearComoMonedaMXN(this.state.FormPago.PedidoCliente.total)}</Typography>
                </Box>
              </Box>
              <Box className='Box2 '>
                <Typography className="TituloBox">Datos del comprador</Typography>
                <Typography className="DatosClientes">Nombre: {this.state.FormPago.PedidoCliente.contactoCliente.nombreCompleto}</Typography>
                <Typography className="DatosClientes">Calle: {this.state.FormFinado.Referencias}</Typography>
                <Typography className="DatosClientes">Ciudad: {this.state.DataDetalleDetalleSetsFuenerarios.Municipio.nombre}, {this.state.DataDetalleDetalleSetsFuenerarios.Estado.nombre}</Typography>
                <Box className='Start'>
                  <Typography className="DatosClientes">Colonia:{this.state.DataDetalleDetalleSetsFuenerarios.Colonia.nombre} </Typography><Typography ml={1} className="DatosClientes"> CP:{this.state.FormFinado.CodigoPostal}</Typography>
                </Box>
              </Box>
              <NotaVenta NoButton={true} ListCarritoIncluido={this.state.ListCarritoIncluido} HorizontalLinearStepper={HorizontalLinearStepper} StyleDragArea={StyleDragArea} ListHeadersStep={this.state.ListHeadersStep} StepLenght={this.state.StepLenght} handleClick='' formatearComoMonedaMXN={this.formatearComoMonedaMXN}
                Step_Pago={{ TypoAtencion: this.state.TypoAtencion, SetSeleccionado: this.state.SetSelecionado, FormFinado: this.state.FormFinado, FormResponsable: this.state.FormResponsable, OnClickGuardar: TodoDataService.PostNuevoservicio, DataValidarCupon: { Url: '', Token: this.state.Token, Data: this.state.FormPago, SetError: this.setData }, OnClickValidarCupon: TodoDataService.ValidarCupon, FormPago: this.state.FormPago, OnChange: this.handleChange, HandleChangeSingle: this.handleChangeSingle }}
                SubTotalExtra={this.state.SubTotalExtra} SubTotal={this.state.SubTotal}
                Step_Extra={{ EliminarCarritoExtra: this.EliminarCarritoExtra, AgregarCarritoExtra: this.AgregarCarritoExtra, ShowAgregarCarritoExtra: this.state.ShowAgregarCarritoExtra, ProductoSelecionadoExtra: this.state.ProductoSelecionadoExtra, OnClickShowAgregarCarritoExtra: this.OnClickShowAgregarCarritoExtra, CargarProductosExtras: this.PeticionProductosExtrasGet, ListProductosExtras: this.state.ListProductosExtra, ListGruposExtras: this.state.ListGruposExtra, ListCarritoExtras: this.state.ListCarritoExtra }}
                Step_PersonalizaSet={{ EliminarCarrito: this.EliminarCarrito, ProductoSelecionado: this.state.ProductoSelecionado, OnClickShowAgregarCarrito: this.OnClickShowAgregarCarrito, ShowAgregarCarrito: this.state.ShowAgregarCarrito, OnClickAgregarCarrito: this.AgregarCarrito, ListProductos: this.state.ListProductos, ListGrupos: this.state.ListGrupos, ListCarrito: this.state.ListCarrito, SeleccionarDespedida: this.SeleccionarDespedida, ListCarritoIncluido: this.state.ListCarritoIncluido }}
                TotalServicioDespedida={this.state.TotalServicioDespedida} ListTypo={ListTypo} FormActualizar={this.state.form} SetNombreSeleccionado={ListSets.find((element) => (element.id === this.state.SetSelecionado)).nombre2} />
            </Box>
          </Box>

          <Box className='Movil'>
            <Box className=''>
              <Box className='BoxLMB1'>
                <Typography variant="h1" className="TituloGracias">Confirmación de pedido</Typography>
                <Box className='Start'>
                  <Typography className="SubTitulo" mr={1}>Número de folio</Typography>
                  <Typography className="SubTitulo Rs">#{this.state.FormPago.PedidoCliente.folio}</Typography>
                </Box>
              </Box>


              <Box className='BoxLMB2'>
                <Typography variant="h2" className="Titulo2">Hola @{this.state.FormPago.PedidoCliente.contactoCliente.nombreCompleto}</Typography>
                <Typography className="SubTitulo2" textAlign='left !important'>
                  Gracias por confiar en nosotros. Tu pedido se ha confirmado, aquí puedes ver los detalles de tu pedido.
                </Typography>
              </Box>
              <Box className='Box1' >
                <Box className='Between' mb='20px'>
                  <Typography className="TituloBox">Costo del servicio</Typography> <Box> {this.TipoPago(this.state.FormPago)}</Box>
                </Box>
                <Box className='Between'>
                  <Typography className="TituloBox"> Total pagado:</Typography>  <Typography className="TotalBox">{this.formatearComoMonedaMXN(this.state.FormPago.PedidoCliente.total)}</Typography>
                </Box>
              </Box>
              <Box className='Box2 '>
                <Typography className="TituloBox">Datos del comprador</Typography>
                <Typography className="DatosClientes">Nombre: {this.state.FormPago.PedidoCliente.contactoCliente.nombreCompleto}</Typography>
                <Typography className="DatosClientes">Calle: {this.state.FormFinado.Direccion}</Typography>
                <Typography className="DatosClientes">Ciudad: {this.state.DataDetalleDetalleSetsFuenerarios.Municipio.nombre}, {this.state.DataDetalleDetalleSetsFuenerarios.Estado.nombre}</Typography>
                <Box className='Start'>
                  <Typography className="DatosClientes">Colonia:{this.state.DataDetalleDetalleSetsFuenerarios.Colonia.nombre} </Typography><Typography ml={1} className="DatosClientes"> CP:{this.state.FormFinado.CodigoPostal}</Typography>
                </Box>
              </Box>
              <NotaVenta NoButton={true} ListCarritoIncluido={this.state.ListCarritoIncluido} HorizontalLinearStepper={HorizontalLinearStepper} StyleDragArea={StyleDragArea} ListHeadersStep={this.state.ListHeadersStep} StepLenght={this.state.StepLenght} handleClick='' formatearComoMonedaMXN={this.formatearComoMonedaMXN}
                Step_Pago={{ TypoAtencion: this.state.TypoAtencion, SetSeleccionado: this.state.SetSelecionado, FormFinado: this.state.FormFinado, FormResponsable: this.state.FormResponsable, OnClickGuardar: TodoDataService.PostNuevoservicio, DataValidarCupon: { Url: '', Token: this.state.Token, Data: this.state.FormPago, SetError: this.setData }, OnClickValidarCupon: TodoDataService.ValidarCupon, FormPago: this.state.FormPago, OnChange: this.handleChange, HandleChangeSingle: this.handleChangeSingle }}
                SubTotalExtra={this.state.SubTotalExtra} SubTotal={this.state.SubTotal}
                Step_Extra={{ EliminarCarritoExtra: this.EliminarCarritoExtra, AgregarCarritoExtra: this.AgregarCarritoExtra, ShowAgregarCarritoExtra: this.state.ShowAgregarCarritoExtra, ProductoSelecionadoExtra: this.state.ProductoSelecionadoExtra, OnClickShowAgregarCarritoExtra: this.OnClickShowAgregarCarritoExtra, CargarProductosExtras: this.PeticionProductosExtrasGet, ListProductosExtras: this.state.ListProductosExtra, ListGruposExtras: this.state.ListGruposExtra, ListCarritoExtras: this.state.ListCarritoExtra }}
                Step_PersonalizaSet={{ EliminarCarrito: this.EliminarCarrito, ProductoSelecionado: this.state.ProductoSelecionado, OnClickShowAgregarCarrito: this.OnClickShowAgregarCarrito, ShowAgregarCarrito: this.state.ShowAgregarCarrito, OnClickAgregarCarrito: this.AgregarCarrito, ListProductos: this.state.ListProductos, ListGrupos: this.state.ListGrupos, ListCarrito: this.state.ListCarrito, SeleccionarDespedida: this.SeleccionarDespedida, ListCarritoIncluido: this.state.ListCarritoIncluido }}
                TotalServicioDespedida={this.state.TotalServicioDespedida} ListTypo={ListTypo} FormActualizar={this.state.form} SetNombreSeleccionado={ListSets.find((element) => (element.id === this.state.SetSelecionado)).nombre2} />



              <Box className='BoxLMB3-2'>
                <Typography variant="h3" className="Titulo3">
Este correo electrónico NO es una confirmación de pago, sino una confirmación de pedido.               
 </Typography>

              </Box>

              <Box className='BoxLMB3'>
                <Typography variant="h3" className="Titulo3">
                  Tu comprobante de pago deberá ser compartido a nuestros asesores, por medio de WhatsApp {this.state.FormPago.PedidoCliente.contactoCliente.telefono} o correo electrónico {this.state.FormPago.PedidoCliente.contactoCliente.email}.
                </Typography>
              </Box>

              <Box className='BoxLMB4 ' display='flex' justifyContent='center'>
                <Typography className="SubTitulo2" display='inline' >
                  Esta notificación fue enviada al correo electrónico ingresado en
                  <Typography className="SubTitulo2 Rs" display='inline'> {TodoDataService.GetHost2()} </Typography>
                  <Typography className="SubTitulo2" display='inline' >
                    Si necesitas alguna aclaración de dudas o servicio al cliente, comunícate al:
                  </Typography>
                </Typography>
              </Box>


              <Box className='BoxLMB5'>
                <Typography variant="h4" className="Titulo2 TC FZ-20">{TodoDataService.GetNumberCall()}</Typography>
              </Box>

              <Box className='BoxLMB6'>
                <Typography className="SubTitulo2 TC">Síguenos en nuestras redes sociales</Typography>
              </Box>

              {/* <Box >
                <img className="ImgRedes" alt="redes" src={redes} />
              </Box> */}


              <Box className='BoxImagen' display='flex' justifyContent='center'>
                <img className="ImgRedes" alt="redes" src={faceboock} style={{ cursor: 'pointer', margin: '0px 10px' }} onClick={() => window.open("https://www.facebook.com/funeralescolumba", "_blank")}
                />
                <img className="ImgRedes" alt="redes" src={instagran} style={{ cursor: 'pointer', margin: '0px 10px' }} onClick={() => window.open("https://www.instagram.com/columbafunerales/", "_blank")}
                />
                <img className="ImgRedes" alt="redes" src={ticktock} style={{ cursor: 'pointer', margin: '0px 10px' }} onClick={() => window.open("https://www.tiktok.com/@funeralescolumba", "_blank")}
                />
              </Box>





              <Typography className="SubTitulo2 TC">
                El correo electrónico se genera automáticamente Por favor, no respondas.
              </Typography>

              {/* <Typography className="SubTitulo2 TC">Por favor, no respondas.</Typography> */}

              <ButtonConmemoracion CopiarFolioSession={ this.CopiarFolioSession} />
            </Box>
          </Box>




        
        </Container>
      </Box>
    );
  }
}

export default SetFunerariosAgradecimientos;

